import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { database, storage } from "../../firebase";
import AsideNewFeed from "../../components/AsideNewFeed";
//import "./addcreditz.css";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import Placeholder from "../../assets/images/Placeholder.png";
import Footer from "../../components/Footer";
import moment from "moment";
import { css } from "@emotion/react";
import { DotLoader } from "react-spinners";
import { toast } from "react-toastify";
import "./viewcreditz.css";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import ReactAudioPlayer from "react-audio-player";
import userImage from "../../assets/images/user";
import YouTube from "react-youtube";

const ViewCreditz = ({ url }) => {
  const [loading, setLoading] = useState(false);
  const [creditz, setCreditz] = useState([]);
  const [usercreditz, setUsercreditz] = useState([]);

  let { id } = useParams();

  const opts = {
    height: "480",
    width: "480",
    playerVars: { rel: 0, showinfo: 0, ecver: 2 },
  };

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: purple;
    color: purple;
    opacity: 0.5;
  `;

  let [color] = useState();
  function GetCreditz() {
    setLoading(true);
    return database
      .ref("/creditz")
      .child(id)
      .once("value")
      .then((snapshot) => {
        const creditz = [];
        creditz.push(snapshot.val());
        setCreditz(creditz);
        setLoading(false);
      });
  }

  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database
        .ref("users/")
        .orderByChild("email")
        .equalTo(uid)
        .once("value", (snap) => {
          resolve(snap.val());
        });
    });
  }

  function GetUserCreditz() {
    return database
      .ref("/user-creditz")
      .child(id)
      .once("value")
      .then(async (snapshot) => {
        const creditz = [];
        let newCreditz = [];
        creditz.push(snapshot.val());

        if (creditz[0] !== null) {
          newCreditz = Object.values(creditz[0]);
        }

        var results = await Promise.all(
          newCreditz.map(async (item) => {
            const data = await getUserData(item.email);
            return { userdetails: data, ...item };
          })
        );
        setUsercreditz(results);
      });
  }

  
  useEffect(() => {
    GetCreditz();
    GetUserCreditz();
  }, []);


  return loading == true ? (
    <DotLoader color={color} css={override} size={100} color={"#7444C0"} />
  ) : (
    <>
      {/* Left Aside */}
      <AsideNewFeed></AsideNewFeed>

      <section className="main-content ">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-5">
              <div className="parent">
                <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
                  <div className="card-header d-flex align-items-center bg-primary px-4 py-2 fw-bold text-white">
                    <Link
                      to="/my-profile"
                      className="d-inline-flex align-middle text-white py-3 pe-4"
                    >
                      <svg className="icon icon-8x">
                        <use href="#icon_arrowback"></use>
                      </svg>
                    </Link>
                  </div>
                </div>
                <div className="child">
                  <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
                    <div className="white">
                      <div className="card-header">
                        <p className="center">
                          Pubished By:
                          <Link to={`/profile/${creditz[0]?.uid}`}>
                            <span className="purple">
                              {" " + creditz[0]?.username}
                            </span>
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card border-0 rounded-xl shadow-xs">
                <div className="card-body p-3 p-sm-4">
                  <div className="mb-2"></div>

                  <div className="row g-4">
                    {creditz[0] && creditz[0].category === "Youtube Video" ? (
                      <div className="col-12 col-md-7 col-xl-7 mb-3 pt-2">
                        <YouTube
                          videoId={creditz[0].youtubevideoid}
                          opts={opts}
                          onEnd={(e) => e.target.stopVideo()}
                        />
                      </div>
                    ) : (
                      <div className="col-12 col-md-4 col-xl-4 mb-3 pt-2">
                        <img
                          src={creditz[0]?.albumImage && creditz[0]?.albumImage}
                          className="w-100 rounded"
                        />
                      </div>
                    )}

                    {creditz[0] && creditz[0].category === "Youtube Video" ? (
                      <div className="col-12 col-md-5 col-xl-5 mb-3">
                        <div className="row g-4">
                          <div className="row g-4">
                            <div className="col-md-12"></div>
                          </div>
                          <div
                            className="col-md-12"
                            style={{ paddingTop: "30px" }}
                          >
                            <div>
                              {" "}
                              <h2> {creditz[0]?.youtubetitle}</h2>{" "}
                            </div>
                            <h3> {creditz[0]?.artistname}</h3>
                            <h3>{creditz[0]?.directorname}</h3>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-12 col-md-8 col-xl-8 mb-3">
                        <div className="row g-4">
                          <div className="col-md-12">
                            <br></br>
                          </div>
                          <div className="col-md-12">
                            <h2>{creditz[0]?.trackname}</h2>
                            <h3>{creditz[0]?.artistname}</h3>
                          </div>

                          <div className="listen">
                            <div className="col-md-12">
                              {creditz[0]?.previewurl == "" ? (
                                <a
                                  href={creditz[0]?.spotifylink}
                                  className="spotify"
                                >
                                  {" "}
                                  Listen on Spotify
                                </a>
                              ) : (
                                <ReactAudioPlayer
                                  src={creditz[0]?.previewurl}
                                  controls
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row"></div>
                  <div className="col-md-2 mb-1"></div>
                </div>
              </div>
            </div>

            <div className="card border-0 rounded-xl shadow-xs">
              <div className="card-body p-3 p-sm-4">
                <div className="mb-2"></div>

                <div className="row g-4">
                  <div className="col-12 col-md-8 col-xl-8 mb-3" id="max">
                    <h2 className="fw-bold pt-4 mb-3" id="creditz">
                      Creditz
                    </h2>
                  </div>
                  <div className="mb-5">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                      {}

                      {usercreditz &&
                        usercreditz.map((cred, index) => {
                          const keys = Object.keys(cred.userdetails);
                         
                          const userDetails = cred.userdetails[keys[0]];
                          return (
                            <div className="col" key={index}>
                              <div className="rounded-xl shadow-xs p-4 bg-white text-center">
                                <img
                                  src={
                                    userDetails.profileImageUrl || userImage()
                                  }
                                  className="image"
                                  alt="user"
                                />
                                {cred.status === "Accepted " ? (
                                  <h5
                                    className="fw-bold mt-3 text-capitalize"
                                    id="purple"
                                  >
                                    <Link to={`/profile/${keys}`}>
                                      {userDetails.firstName}{" "}
                                      {userDetails.lastName}
                                    </Link>
                                  </h5>
                                ) : (
                                  <h5 className="fw-bold mt-3 text-capitalize">
                                    {userDetails.firstName}{" "}
                                    {userDetails.lastName}
                                  </h5>
                                )}

                                <div className="d-flex flex-wrap justify-content-evenly my-4 text-muted">
                                  <div className="px-1">
                                    <h4 className="fw-bold fs-6 mb-0">
                                      {cred?.role}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </section>
    </>
  );
};

export default ViewCreditz;
